import React, { ChangeEvent } from "react";
import { ImagePlus, Trash2Icon } from "lucide-react";
import { useTranslation } from "react-i18next";

interface Props {
  image: File | string | null;
  setImage: (file: File | null) => void;
  label: string;
}

const SingleImageUploader: React.FC<Props> = ({ image, setImage, label }) => {
  const { t } = useTranslation();

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || !e.target.files[0]) return;
    setImage(e.target.files[0]);
    e.target.value = "";
  };

  const handleRemove = () => {
    setImage(null);
  };

  return (
    <div className="flex flex-col gap-2">
      {!image && (
        <label className="w-32 h-32 flex flex-col items-center justify-center border-2 border-dashed rounded-2xl cursor-pointer hover:border-primary transition relative">
          <ImagePlus className="text-2xl text-gray-400" />
          <span className="text-xs mt-1 text-gray-500">{t(label)}</span>
          <input type="file" accept="image/*" className="hidden" onChange={handleFileChange} />
        </label>
      )}

      {image && (
        <div className="relative w-32 h-32 rounded-2xl overflow-hidden shadow-md">
          <img
            src={image instanceof File ? URL.createObjectURL(image) : image}
            alt="preview"
            className="w-full h-full object-cover"
          />
          <button
            onClick={handleRemove}
            className="absolute top-1 right-1 text-red-600 bg-white rounded-full w-6 h-6 flex items-center justify-center"
          >
            <Trash2Icon size={14} />
          </button>
        </div>
      )}
    </div>
  );
};

export default SingleImageUploader;
